export default __webpack_public_path__ + "static/old-logo-black-072495a3e50dd4ddc3abc04218a0afc2.png";